// extracted by mini-css-extract-plugin
export default {"parallax":"Parallax_parallax__SBfF3","parallaxInner":"Parallax_parallaxInner__UP0yG"};